/**
 * Dummy data — 목적지/공통 데이터 (서비스 + 관리자)
 * API_DOCS: 8. 공통 데이터 / 21. 관리자 - 목적지
 *
 * Airport: id, code, name, is_active
 * Golf: id, name, region, address, is_recommended, is_active, sort_order
 * SkiResort: id, name, region, is_active
 * Hospital: id, name, region, hospital_region_id, address, is_recommended, is_active, sort_order
 * DepartureRegion: id, name, incheon_price, gimpo_price, is_active
 * HospitalRegion: id, name, price, lat, lng
 *
 * 7. 가용성 (Availability):
 *   GET /api/availability/check → { date, available, booked_count }
 *   GET /api/availability/calendar → { year, month, booked_dates }
 */

/* ── 공항 ── */
const airports = [
  { code: 'ICN_T1', name: '인천국제공항 제1터미널', latitude: '37.4602', longitude: '126.4407' },
  { code: 'ICN_T2', name: '인천국제공항 제2터미널', latitude: '37.4529', longitude: '126.4464' },
  { code: 'GMP_I', name: '김포공항 국제선', latitude: '37.5585', longitude: '126.7906' },
  { code: 'GMP_D', name: '김포공항 국내선', latitude: '37.5585', longitude: '126.7906' },
];

/* ── 골프장 (지역별) ── */
const golfCourses = [
  /* 경기 TOP 20 */
  { id: 1, name: '뉴스프링빌C.C.', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 1 },
  { id: 2, name: '웰링턴C.C.', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 2 },
  { id: 3, name: '아난티클럽 서울', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 3 },
  { id: 4, name: '레이크사이드CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 4 },
  { id: 5, name: '남서울컨트리클럽', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 5 },
  { id: 6, name: '블랙스톤리조트이천', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 6 },
  { id: 7, name: '스카이밸리', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 7 },
  { id: 8, name: '해슬리나인브릿지', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 8 },
  { id: 9, name: '프리스틴밸리G.C', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 9 },
  { id: 10, name: '한양컨트리클럽', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 10 },
  { id: 11, name: '수원CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 11 },
  { id: 12, name: '플라자CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 12 },
  { id: 13, name: '골드CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 13 },
  { id: 14, name: '88CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 14 },
  { id: 15, name: '아시아나CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 15 },
  { id: 16, name: '리베라CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 16 },
  { id: 17, name: '기흥CC', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 17 },
  { id: 18, name: '뉴서울컨트리클럽', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 18 },
  { id: 19, name: '비에이비스타C.C.', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 19 },
  { id: 20, name: '솔모로', region: 'gyeonggi', is_recommended: true, is_active: true, sort_order: 20 },
  /* 인천 전체 12개 */
  { id: 21, name: '인천국제컨트리클럽', region: 'incheon', is_recommended: true, is_active: true, sort_order: 1 },
  { id: 22, name: '잭 니클라우스 골프클럽 코리아', region: 'incheon', is_recommended: true, is_active: true, sort_order: 2 },
  { id: 23, name: 'SKY72 골프클럽(바다코스)', region: 'incheon', is_recommended: true, is_active: true, sort_order: 3 },
  { id: 24, name: 'SKY72 골프클럽(하늘코스)', region: 'incheon', is_recommended: true, is_active: true, sort_order: 4 },
  { id: 25, name: '드림파크골프장', region: 'incheon', is_recommended: true, is_active: true, sort_order: 5 },
  { id: 26, name: '베어즈베스트청라골프클럽', region: 'incheon', is_recommended: true, is_active: true, sort_order: 6 },
  { id: 27, name: '인천그랜드컨트리클럽', region: 'incheon', is_recommended: true, is_active: true, sort_order: 7 },
  { id: 28, name: '오렌지듄스골프클럽', region: 'incheon', is_recommended: true, is_active: true, sort_order: 8 },
  { id: 29, name: '석모도컨트리클럽', region: 'incheon', is_recommended: true, is_active: true, sort_order: 9 },
  { id: 30, name: '영종오렌지골프장', region: 'incheon', is_recommended: true, is_active: true, sort_order: 10 },
  { id: 31, name: '강화 선두리 골프장', region: 'incheon', is_recommended: true, is_active: true, sort_order: 11 },
  { id: 32, name: '송도골프클럽', region: 'incheon', is_recommended: true, is_active: true, sort_order: 12 },
  /* 강원 TOP 20 */
  { id: 33, name: '오크밸리골프장', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 1 },
  { id: 34, name: '웰리힐리컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 2 },
  { id: 35, name: '라데나골프클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 3 },
  { id: 36, name: '엘리시안 강촌컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 4 },
  { id: 37, name: '휘슬링락컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 5 },
  { id: 38, name: '알펜시아컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 6 },
  { id: 39, name: '용평리조트골프클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 7 },
  { id: 40, name: '용평버치힐골프클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 8 },
  { id: 41, name: '휘닉스 컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 9 },
  { id: 42, name: '제이드팰리스 골프클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 10 },
  { id: 43, name: 'Oak Hills컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 11 },
  { id: 44, name: '센추리21컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 12 },
  { id: 45, name: '샌드파인골프클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 13 },
  { id: 46, name: '설악프라자컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 14 },
  { id: 47, name: '소노펠리체CC 비발디파크 웨스트', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 15 },
  { id: 48, name: '소노펠리체CC 비발디파크 이스트', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 16 },
  { id: 49, name: '소노펠리체CC 비발디파크 마운틴', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 17 },
  { id: 50, name: '라비에벨컨트리클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 18 },
  { id: 51, name: '더플레이어스 골프클럽', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 19 },
  { id: 52, name: '세이지우드CC홍천', region: 'gangwon', is_recommended: true, is_active: true, sort_order: 20 },
];

/* ── 스키장 ── */
const skiResorts = [
  { id: 1, name: '곤지암 리조트', region: 'gyeonggi', price: 399000, is_active: true },
  { id: 2, name: '지산 리조트', region: 'gyeonggi', price: 399000, is_active: true },
  { id: 3, name: '비발디파크', region: 'gangwon', price: 449000, is_active: true },
  { id: 4, name: '엘리시안 강촌', region: 'gangwon', price: 449000, is_active: true },
  { id: 5, name: '베어스타운', region: 'gyeonggi', price: 399000, is_active: true },
];

/* ── 차량 ── */
const vehicles = [
  { id: 1, name: '2026년 신형 스타리아 라운지 블랙', vehicle_type: 'van', min_passengers: 4, max_passengers: 6, description: '2열 프리미엄 릴렉션 시트', luggage: '28인치 이하 캐리어 4개(기본)', status: 'active', is_active: true, is_default: true },
];

/* ── 서비스별 버퍼(무료 대기/기본 운행) 설정 ── */
const bufferSettings = [
  { id: 1, service_type: 'airport', direction: 'pickup', buffer_before_minutes: 30, buffer_after_minutes: 60, free_waiting_minutes: 60, base_driving_minutes: 60, overtime_price_per_hour: 19900, description: '공항 픽업 전후 버퍼' },
  { id: 2, service_type: 'airport', direction: 'sending', buffer_before_minutes: 60, buffer_after_minutes: 30, free_waiting_minutes: 30, base_driving_minutes: 60, overtime_price_per_hour: 19900, description: '공항 센딩 전후 버퍼' },
  { id: 3, service_type: 'golf', direction: 'base', buffer_before_minutes: 540, buffer_after_minutes: 0, free_waiting_minutes: null, base_driving_minutes: 540, overtime_price_per_hour: 39900, description: '기본 이용시간 9시간' },
  { id: 4, service_type: 'ski', direction: 'base', buffer_before_minutes: 540, buffer_after_minutes: 0, free_waiting_minutes: null, base_driving_minutes: 540, overtime_price_per_hour: 39900, description: '기본 이용시간 9시간' },
  { id: 5, service_type: 'hospital', direction: 'base', buffer_before_minutes: 120, buffer_after_minutes: 0, free_waiting_minutes: null, base_driving_minutes: 120, overtime_price_per_hour: 39900, description: '기본 이용시간 2시간' },
  { id: 6, service_type: 'pet', direction: 'base', buffer_before_minutes: 120, buffer_after_minutes: 0, free_waiting_minutes: null, base_driving_minutes: 120, overtime_price_per_hour: 39900, description: '기본 이용시간 2시간' },
  { id: 7, service_type: 'business', direction: 'base', buffer_before_minutes: 120, buffer_after_minutes: 0, free_waiting_minutes: null, base_driving_minutes: 120, overtime_price_per_hour: 39900, description: '기본 이용시간 2시간' },
];

/* ── 병원 ── */
const hospitals = [
  { id: 1, name: '가톨릭대 서울성모병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 1 },
  { id: 2, name: '강남세브란스병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 2 },
  { id: 3, name: '삼성서울병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 3 },
  { id: 4, name: '서울대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 4 },
  { id: 5, name: '서울아산병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 5 },
  { id: 6, name: '세브란스병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 6 },
  { id: 7, name: '고려대학교안암병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 7 },
  { id: 8, name: '경희대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 8 },
  { id: 9, name: '한양대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 9 },
  { id: 10, name: '중앙대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 10 },
  { id: 11, name: '이화여자대학교목동병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 11 },
  { id: 12, name: '건국대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 12 },
  { id: 13, name: '순천향대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 13 },
  { id: 14, name: '강북삼성병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 14 },
  { id: 15, name: '보라매병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 15 },
  { id: 16, name: '노원을지대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 16 },
  { id: 17, name: '한림대학교강동성심병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 17 },
  { id: 18, name: '한림대학교강남성심병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 18 },
  { id: 19, name: '강동경희대학교병원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 19 },
  { id: 20, name: '국립중앙의료원', region: '서울', hospital_region_id: 1, is_recommended: true, is_active: true, sort_order: 20 },
  { id: 21, name: '분당서울대학교병원', region: '분당', hospital_region_id: 2, is_recommended: true, is_active: true, sort_order: 1 },
  { id: 22, name: '분당제생병원', region: '분당', hospital_region_id: 2, is_recommended: true, is_active: true, sort_order: 2 },
  { id: 23, name: '분당차병원', region: '분당', hospital_region_id: 2, is_recommended: true, is_active: true, sort_order: 3 },
];

// BugHerd #68/#69: 광역 단위(서울/경기 북부/경기 남부) row 는 #34 구·시·군 세분화 작업으로 폐기.
const departureRegions = [
  { id: 1, name: '강남구', parent_region: '서울', region_type: 'district', incheon_price: 139000, gimpo_price: 109000, is_active: true },
  { id: 2, name: '노원구', parent_region: '서울', region_type: 'district', incheon_price: 149000, gimpo_price: 119000, is_active: true },
  { id: 3, name: '고양시', parent_region: '경기', region_type: 'city',     incheon_price: 139000, gimpo_price: 129000, is_active: true },
];

const hospitalRegions = [
  { id: 1, name: '서울', price: 150000, lat: 37.5665, lng: 126.9780 },
  { id: 2, name: '경기', price: 180000, lat: 37.4138, lng: 127.5183 },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) — 공통 데이터 ── */

/** GET /api/airports (query: search) */
export const getAirports = async (params = {}) => {
  await delay(200);
  let filtered = [...airports];
  if (params.search) {
    const q = params.search.toLowerCase();
    filtered = filtered.filter((a) => a.name.toLowerCase().includes(q));
  }
  return { key: 'airports', items: filtered };
};

/** GET /api/golf-courses (query: search, region) */
export const getGolfCourses = async (params = {}) => {
  await delay(200);
  let filtered = golfCourses.filter((g) => g.is_active);
  if (params.region) {
    filtered = filtered.filter((g) => g.region === params.region);
  }
  if (params.search) {
    const q = params.search.toLowerCase();
    filtered = filtered.filter((g) => g.name.toLowerCase().includes(q));
  }
  return filtered;
};

/** GET /api/ski-resorts (query: search) */
export const getSkiResorts = async (params = {}) => {
  await delay(200);
  let filtered = skiResorts.filter((r) => r.is_active);
  if (params.search) {
    const q = params.search.toLowerCase();
    filtered = filtered.filter((r) => r.name.toLowerCase().includes(q));
  }
  return filtered;
};

/** GET /api/hospitals (query: search, region) */
export const getHospitals = async (params = {}) => {
  await delay(200);
  let filtered = hospitals.filter((h) => h.is_active);
  if (params.region) {
    filtered = filtered.filter((h) => h.region === params.region);
  }
  if (params.search) {
    const q = params.search.toLowerCase();
    filtered = filtered.filter((h) => h.name.toLowerCase().includes(q));
  }
  return filtered;
};

/* ── 서비스 — 가용성 ── */

/** GET /api/availability/check */
export const checkAvailability = async (params = {}) => {
  await delay(200);
  return { date: params.date, available: true, booked_count: 2 };
};

/** GET /api/availability/calendar */
export const getAvailabilityCalendar = async (params = {}) => {
  await delay(300);
  return { year: params.year || 2026, month: params.month || 3, booked_dates: ['2026-03-10', '2026-03-15', '2026-03-20'] };
};

/** GET /api/buffer-settings?service_type= */
export const getBufferSettings = async (serviceType) => {
  await delay(150);
  return serviceType
    ? bufferSettings.filter((b) => b.service_type === serviceType)
    : bufferSettings;
};

/** GET /api/vehicles */
export const getVehicles = async () => {
  await delay(150);
  return vehicles.filter((v) => v.is_active);
};

/* ── 관리자 — 골프장 CRUD ── */

export const getAdminGolfCourses = async (params = {}) => {
  await delay(300);
  return golfCourses;
};

export const createAdminGolfCourse = async (data) => {
  await delay(400);
  const course = { id: golfCourses.length + 1, name: data.name || null, region: data.region || 'gyeonggi', is_recommended: data.is_recommended || false, is_active: data.is_active !== undefined ? data.is_active : true, sort_order: golfCourses.length + 1 };
  golfCourses.push(course);
  return course;
};

export const updateAdminGolfCourse = async (id, data) => {
  await delay(400);
  const idx = golfCourses.findIndex((g) => g.id === Number(id));
  if (idx === -1) throw new Error('골프장을 찾을 수 없습니다');
  golfCourses[idx] = { ...golfCourses[idx], ...data };
  return golfCourses[idx];
};

export const deleteAdminGolfCourse = async (id) => {
  await delay(300);
  const idx = golfCourses.findIndex((g) => g.id === Number(id));
  if (idx === -1) throw new Error('골프장을 찾을 수 없습니다');
  golfCourses.splice(idx, 1);
  return { message: '골프장이 삭제되었습니다' };
};

/* ── 관리자 — 병원 CRUD ── */

export const getAdminHospitals = async (params = {}) => {
  await delay(300);
  return hospitals;
};

export const createAdminHospital = async (data) => {
  await delay(400);
  const hospital = { id: hospitals.length + 1, name: data.name || null, region: data.region || '서울', hospital_region_id: data.hospital_region_id || null, is_recommended: data.is_recommended || false, is_active: data.is_active !== undefined ? data.is_active : true, sort_order: hospitals.length + 1 };
  hospitals.push(hospital);
  return hospital;
};

export const updateAdminHospital = async (id, data) => {
  await delay(400);
  const idx = hospitals.findIndex((h) => h.id === Number(id));
  if (idx === -1) throw new Error('병원을 찾을 수 없습니다');
  hospitals[idx] = { ...hospitals[idx], ...data };
  return hospitals[idx];
};

export const deleteAdminHospital = async (id) => {
  await delay(300);
  const idx = hospitals.findIndex((h) => h.id === Number(id));
  if (idx === -1) throw new Error('병원을 찾을 수 없습니다');
  hospitals.splice(idx, 1);
  return { message: '병원이 삭제되었습니다' };
};

/* ── 관리자 — 출발 지역 CRUD ── */

export const getAdminDepartureRegions = async () => {
  await delay(200);
  return departureRegions;
};

export const createAdminDepartureRegion = async (data) => {
  await delay(400);
  const region = { id: departureRegions.length + 1, ...data, is_active: data.is_active !== undefined ? data.is_active : true };
  departureRegions.push(region);
  return region;
};

export const updateAdminDepartureRegion = async (id, data) => {
  await delay(400);
  const idx = departureRegions.findIndex((r) => r.id === Number(id));
  if (idx === -1) throw new Error('지역을 찾을 수 없습니다');
  departureRegions[idx] = { ...departureRegions[idx], ...data };
  return departureRegions[idx];
};

export const deleteAdminDepartureRegion = async (id) => {
  await delay(300);
  const idx = departureRegions.findIndex((r) => r.id === Number(id));
  if (idx === -1) throw new Error('지역을 찾을 수 없습니다');
  departureRegions.splice(idx, 1);
  return { message: '지역이 삭제되었습니다' };
};

/* ── 관리자 — 병원 지역 CRUD ── */

export const getAdminHospitalRegions = async () => {
  await delay(200);
  return hospitalRegions;
};

export const createAdminHospitalRegion = async (data) => {
  await delay(400);
  const region = { id: hospitalRegions.length + 1, ...data };
  hospitalRegions.push(region);
  return region;
};

export const updateAdminHospitalRegion = async (id, data) => {
  await delay(400);
  const idx = hospitalRegions.findIndex((r) => r.id === Number(id));
  if (idx === -1) throw new Error('지역을 찾을 수 없습니다');
  hospitalRegions[idx] = { ...hospitalRegions[idx], ...data };
  return hospitalRegions[idx];
};

export const deleteAdminHospitalRegion = async (id) => {
  await delay(300);
  const idx = hospitalRegions.findIndex((r) => r.id === Number(id));
  if (idx === -1) throw new Error('지역을 찾을 수 없습니다');
  hospitalRegions.splice(idx, 1);
  return { message: '지역이 삭제되었습니다' };
};
